// update state
const setTaskNameAction = (payload) => {
    return {
            type: "TASKNAME",
            payload
        }

}

export default setTaskNameAction;


// update state






// WEBPACK FOOTER //
// ./src/actions/setTaskNameAction.js